// src/componentes/Cuerpos/submoduloscomunes/ListaDespachosModal/ListaDespachosModal.js

import React, { useState, useEffect, useRef } from 'react'; // <-- Importar useRef
import './ListaDespachosModal.css';
import Swal from 'sweetalert2';
import BuscarEmpleadoModal from '../../../submoduloscomunes/BuscarEmpleado/BuscarEmpleadoModal';
import PuenteApi from '../../../../../pageauth/PuenteApi';

const ListaDespachosModal = ({ isVisible, onSelectdespacho, onClose, SetMensaje }) => {
    const { VerificarPassEmpleadoDespacho, ObtenerDespachos } = PuenteApi()
    const [despachosData, setdespachosData] = useState([{ codigo: '-', hora: '-', combustible: 'Cargando informacion...', surtidor: 0, manguera: 0, litros: '-', importe: '-', estado: '-' }]);
    const [showBuscarEmpleadoModal, setShowBuscarEmpleadoModal] = useState(false);

    const [selectedIndex, setSelectedIndex] = useState(0);
    const totalDespachos = despachosData.length;


    const obteneDespachos2 = async () => {
        try {
            const response = await ObtenerDespachos();
            if (response && Array.isArray(response) && response.length > 0) {
                setdespachosData(response);
            } else {
                SetMensaje("Error", "No se encontraron despachos", 3000);
                setdespachosData([{ codigo: 'ERROR', hora: 'ERROR', combustible: 'No se encontraron despachos', surtidor: 0, manguera: 0, litros: '-', importe: '-', estado: '-' }]);
            }
        } catch (error) {
            setdespachosData([]);
            SetMensaje("Error", "Hubo un problema con la solicitud " + error, 3000);
        }
    };

    useEffect(() => {
        if (isVisible) {
            setdespachosData([]);
            setSelectedIndex(0);
            obteneDespachos2();
        }
    }, [isVisible]);

    // Referencia para el contenedor de la tabla para el auto-scroll
    const tableContainerRef = useRef(null);

    const tableHeaderRef = useRef(null); // <-- Nueva ref para el encabezado
    const scrollInstructionRef = useRef('nearest'); // Ref para la dirección del scroll

    // Función para manejar la selección (doble click o Enter)
    const handleSelect = async (index) => {
        const selectedDespacho = despachosData[index];
        if (selectedDespacho) {
            if (selectedDespacho.estado == "FACTURADO") {
                SetMensaje("Error", "No se puede agregar un despacho facturado", 3000);
                return;
            }
            if (selectedDespacho.estado == "VENCIDO") {
                const result = await Swal.fire({
                    title: 'Solo un usuario con permisos puede facturar este despacho',
                    showCancelButton: true,
                    confirmButtonText: 'Continuar',
                    cancelButtonText: 'Cancelar'
                });
                if (result.isConfirmed) {
                    setShowBuscarEmpleadoModal(true);
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    Swal.fire('Operacion Cancelada', '', 'info');
                }
            }
            if (selectedDespacho.estado == "DISPONIBLE") {
                onSelectdespacho(selectedDespacho);
            }
        }
    };

    const verificar_empleado = async (empleado, password) => {
        const resultado = await VerificarPassEmpleadoDespacho(empleado.nombre_solo, empleado.apellido_solo, empleado.id, password);
        if (resultado != true) {
            return;
        } else {
            const selectedDespacho = despachosData[selectedIndex];
            onSelectdespacho(selectedDespacho);
        }
    }

    const handleSelectEmpleado = (empleado) => {
        Swal.fire({
            title: 'Ingrese su contraseña',
            input: 'password',
            inputLabel: empleado.nombre,
            inputPlaceholder: 'Ingrese su contraseña aqui...',
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cancelar',
            inputValidator: (value) => {
                if (!value) {
                    return 'Necesita escribir una contraseña!';
                }
            }
        }).then((result) => {
            if (result.isConfirmed) {
                verificar_empleado(empleado, result.value);
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire('Operacion Cancelada', '', 'info');
            }
        });
    };

    // 1. Manejador de eventos de teclado
    const handleKeyDown = (e) => {
        if (!isVisible) return;
        if (showBuscarEmpleadoModal) {
            return;
        }
        if (['ArrowUp', 'ArrowDown', 'Enter', 'Escape'].includes(e.key)) {
            e.preventDefault();
        }

        switch (e.key) {
            case 'ArrowDown':
                // Al bajar, usamos 'nearest'
                scrollInstructionRef.current = 'nearest';
                setSelectedIndex(prevIndex => (prevIndex + 1) % totalDespachos);
                break;
            case 'ArrowUp':
                // Al subir, usamos 'start' para forzar la compensación en el useEffect
                scrollInstructionRef.current = 'start';
                setSelectedIndex(prevIndex => (prevIndex - 1 + totalDespachos) % totalDespachos);
                break;
            case 'Enter':
                scrollInstructionRef.current = 'nearest';
                setSelectedIndex(prevIndex => {
                    handleSelect(prevIndex);
                    return prevIndex;
                });
                break;
            case 'Escape':
                onClose();
                break;
            default:
                break;
        }
    };

    // 2. Hook para adjuntar/desmontar el manejador de teclado
    useEffect(() => {
        if (isVisible) {
            window.addEventListener('keydown', handleKeyDown);
            return () => {
                window.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [isVisible, totalDespachos, handleSelect, onClose, !showBuscarEmpleadoModal]);

    // 3. Hook para manejar el **Auto-Scroll** de la fila seleccionada
    useEffect(() => {
        if (isVisible && tableContainerRef.current) {
            const container = tableContainerRef.current;
            const selectedRow = container.querySelector(`.despachos-table tbody tr:nth-child(${selectedIndex + 1})`);

            if (selectedRow) {
                // Obtenemos la altura del encabezado. Usamos un valor fijo si la ref no está lista o tiene altura 0.
                const headerHeight = tableHeaderRef.current
                    ? tableHeaderRef.current.offsetHeight
                    : 35; // Altura de respaldo si el CSS no carga a tiempo

                // Si el movimiento fue hacia arriba (ArrowUp)
                if (scrollInstructionRef.current === 'start') {

                    // Cálculo de la nueva posición de scroll:
                    // newScrollTop = posición actual de la fila - altura del encabezado (OFFSET)
                    const newScrollTop = selectedRow.offsetTop - headerHeight;

                    // Aplicar el scroll MANUALMENTE con el offset
                    container.scrollTo({
                        top: newScrollTop,
                        behavior: 'smooth'
                    });

                } else {
                    // Si el movimiento fue hacia abajo o un click, usamos el método 'nearest'
                    selectedRow.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                    });
                }

                // Reseteamos la instrucción después de aplicarla
                scrollInstructionRef.current = 'nearest';
            }
        }
    }, [selectedIndex, isVisible, !showBuscarEmpleadoModal]);

    useEffect(() => {
        if (isVisible) {
            setSelectedIndex(0)
        }
    }, [isVisible]); // Se ejecuta cada vez que la selección cambia


    // Función para manejar la selección por click
    const handleClick = (index) => {
        scrollInstructionRef.current = 'nearest'; // El click debe usar 'nearest'
        setSelectedIndex(index);
    };

    // Función para determinar la clase de color para la hora según el estado (simulación)
    const getEstadoClass = (estado, campo) => {
        if (campo == "hora") {
            switch (estado) {
                case 'DISPONIBLE': return 'hora-disponible';
                case 'VENCIDO': return 'hora-vencido';
                case 'FACTURADO': return 'hora-facturado';
                default: return '';
            }
        } else {
            switch (estado) {
                case 'DISPONIBLE': return 'text-green';
                case 'VENCIDO': return 'text-blue';
                case 'FACTURADO': return 'text-red';
                default: return '';
            }
        }
    };

    const ordenarDespachos = (despachos) => {
        const estadoOrden = {
            'DISPONIBLE': 0,
            'VENCIDO': 1,
            'FACTURADO': 2,
        };

        return despachos.sort((a, b) => estadoOrden[a.estado] - estadoOrden[b.estado]);
    };

    const despachosOrdenados = ordenarDespachos(despachosData);

    if (!isVisible) return null;

    return (
        <>
            <BuscarEmpleadoModal
                isVisible={showBuscarEmpleadoModal}
                onClose={() => setShowBuscarEmpleadoModal(false)}
                onSelectempleado={handleSelectEmpleado}
            />
            <div
                className="modal-overlay-despachos"
            // La navegación de teclado se gestiona a nivel de window, no del div
            >
                <div className="modal-content-despachos">
                    <div className="modal-header-despachos">
                        Lista de Despachos
                    </div>

                    <div className="modal-body-despachos">
                        <div className="despachos-label">Despachos</div>
                        <table className="despachos-table">
                            <thead>
                                <tr ref={tableHeaderRef}> {/* <-- ¡Aquí asignamos la referencia al encabezado! */}
                                    <th>HORA</th>
                                    <th>COMBUSTIBLE</th>
                                    <th>SURTIDOR</th>
                                    <th>MANGUERA</th>
                                    <th>LITROS/M3</th>
                                    <th>IMPORTE $</th>
                                </tr>
                            </thead>
                        </table>
                        {/* Tabla de Despachos */}
                        <div className="despachos-table-container" ref={tableContainerRef}>
                            <table className="despachos-table">
                                <tbody>
                                    {despachosOrdenados.map((despacho, index) => (
                                        <tr
                                            key={index}
                                            className={index === selectedIndex ? 'selected-row' : ''}
                                            onClick={() => handleClick(index)}
                                            onDoubleClick={() => handleSelect(index)}
                                        >
                                            <td className={getEstadoClass(despacho.estado, "hora")}>{despacho.hora}</td>
                                            <td className={getEstadoClass(despacho.estado, "otro")}>{despacho.combustible}</td>
                                            <td className={getEstadoClass(despacho.estado, "otro")}>{despacho.surtidor}</td>
                                            <td className={getEstadoClass(despacho.estado, "otro")}>{despacho.manguera}</td>
                                            <td className={getEstadoClass(despacho.estado, "otro")}>{despacho.litros}</td>
                                            <td className={getEstadoClass(despacho.estado, "otro")}>$ {despacho.importe}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Footer con Leyendas de Color y Botón Salir */}
                    <div className="modal-footer-despachos">
                        <div className="leyendas-container">
                            <div className="leyenda">
                                <span className="color-box disponible"></span> Despachos Disponibles
                            </div>
                            <div className="leyenda">
                                <span className="color-box vencido"></span> Despachos Vencidos
                            </div>
                            <div className="leyenda">
                                <span className="color-box facturado"></span> Despachos Facturados
                            </div>
                        </div>

                        <button
                            className="btn-salir-despachos"
                            onClick={onClose}
                        >
                            <span className="icon-btn">❌</span> Salir
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ListaDespachosModal;